import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ApiService } from '../../../Components/Services/apiServices';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import Header from '../../../Components/Header';
import Footer from '../../../Components/Footer';
import { FaHeart, FaLocationArrow, FaStar } from 'react-icons/fa';
import { useWishlist } from '../../../Components/Context/WishlistContext';
const IMAGE_BASE_URL = "https://www.adminfamilyfun.jewelscraze.com/front/images/rooms/";

const CategoryListing = () => {
    const { url } = useParams();
    const [userLocation, setUserLocation] = useState(null);
    const [loading, setLoading] = useState(true);
    const [rooms, setRooms] = useState([]);
    const [hovered, setHovered] = useState(false);
    const { wishlist, toggleWishlistItem, handleRemoveFromWishlist } = useWishlist();

    useEffect(() => {
        const fetchCategoryRooms = async (categoryUrl) => {
            try {
                setLoading(true);
                const response = await ApiService.Commanfetchrequest(
                    `properties?category_url=${encodeURIComponent(categoryUrl)}`
                );
                setRooms(response);
                console.log(response);
            } catch (error) {
                console.error('Error fetching category rooms:', error);
            } finally {
                setLoading(false);
            }
        };

        const getUserLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        const { latitude, longitude } = position.coords;
                        setUserLocation({ latitude, longitude });
                    },
                    (error) => {
                        console.error("Geolocation error:", error);
                    }
                );
            } else {
                console.warn("Geolocation not supported.");
            }
        };

        if (url) {
            fetchCategoryRooms(url);
        }
        getUserLocation();
    }, [url]);

    const getDistanceFromLatLonInKm = (lat1, lon1, lat2, lon2) => {
        const R = 6371;
        const dLat = (lat2 - lat1) * (Math.PI / 180);
        const dLon = (lon2 - lon1) * (Math.PI / 180);
        const a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(lat1 * (Math.PI / 180)) * Math.cos(lat2 * (Math.PI / 180)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        const d = R * c;
        return d;
    };

    return (
        <>
            <Header />
            <div className="container listings-container">
                {loading ? (
                    <>
                        {[...Array(4)].map((_, index) => (
                            <div key={index} className="listing-card">
                                <div className="image-container">
                                    <Skeleton height={200} />
                                </div>
                                <div className="listing-info">
                                    <h3><Skeleton width={`80%`} /></h3>
                                    <p><Skeleton width={`60%`} /></p>
                                    <p><Skeleton width={`40%`} /></p>
                                </div>
                            </div>
                        ))}
                    </>
                ) : rooms.length > 0 ? (
                    <>
                        {rooms.map((room, index) => (
                            <div key={index} className="listing-card">
                                <div className="image-container">
                                    <Link to={`/property-details/${room.room_name}`}>
                                        <Swiper
                                            modules={[Pagination]}
                                            spaceBetween={10}
                                            slidesPerView={1}
                                            pagination={{ clickable: true }}
                                        >
                                            {room.room_images && room.room_images.length > 0 ? (
                                                room.room_images.map((img, index) => (
                                                    <SwiperSlide key={index}>
                                                        <img
                                                            src={`${IMAGE_BASE_URL}${img.room_images}`}
                                                            alt={`${room.room_name} - ${index}`}
                                                            className="listing-image"
                                                        />
                                                    </SwiperSlide>
                                                ))
                                            ) : (
                                                <SwiperSlide>
                                                    <img
                                                        src="/images/default-property.jpg"
                                                        alt="Default"
                                                        className="listing-image"
                                                    />
                                                </SwiperSlide>
                                            )}
                                        </Swiper>
                                    </Link>
                                    <div
                                        className="wishlist-icon"
                                        style={{
                                            position: "absolute",
                                            top: "10px",
                                            right: "10px",
                                            zIndex: 10,
                                            cursor: "pointer",
                                            transition: "transform 0.2s ease",
                                        }}
                                        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.2)")}
                                        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                        onClick={() => toggleWishlistItem(room)}
                                    >
                                        <FaHeart style={{
                                            color: wishlist.some((item) => item.room_name === room.room_name)
                                                ? "red"
                                                : "white", fontSize: "1.5rem"
                                        }} />
                                    </div>
                                </div>
                                <div className="listing-info">
                                    <h3>{room.room_name}</h3>
                                    <p>{room.location}</p>
                                    {userLocation && room.latitude && room.longitude ? (
                                        <>
                                            <FaLocationArrow className="star-icon" style={{ color: "red" }} />
                                            <a
                                                href={`https://www.google.com/maps/dir/?api=1&origin=${userLocation.latitude},${userLocation.longitude}&destination=${room.latitude},${room.longitude}`}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                style={{
                                                    textDecoration: 'none',
                                                    color: hovered ? 'blue' : '#000',
                                                    marginLeft: '5px',
                                                    transition: 'color 0.2s ease',
                                                }}
                                                onMouseEnter={() => setHovered(true)}
                                                onMouseLeave={() => setHovered(false)}
                                            >
                                                {(() => {
                                                    const distanceKm = getDistanceFromLatLonInKm(
                                                        userLocation.latitude,
                                                        userLocation.longitude,
                                                        parseFloat(room.latitude),
                                                        parseFloat(room.longitude)
                                                    );
                                                    return distanceKm < 1
                                                        ? `${Math.round(distanceKm * 1000)} m away`
                                                        : `${distanceKm.toFixed(1)} km away`;
                                                })()}
                                            </a>
                                        </>
                                    ) : (
                                        <FaLocationArrow className="star-icon" style={{ color: "gray" }} />
                                    )}
                                    <p><FaStar className="star-icon" /> 4.9</p>
                                </div>
                            </div>
                        ))}


                    </>
                ) : (
                    <p>No Items found for this category.</p>
                )}

            </div>

            <Footer />
        </>

    );
};



export default CategoryListing;
